import React from "react";

const Terms = () => {
  const pdfUrl = 'https://vertice-ds.s3.amazonaws.com/Assets/Images/Templates/AcessaAgro/Terms/RG+Acessa+Niver+VB+Aprovado.pdf?#zoom=125&toolbar=0&embedded=true'
  return (
    <div>
      <iframe
        src={pdfUrl}
        width="100%"
        height="500px"
        title="PDF Viewer"
        style={{ border: 'none' }}
      >
        Seu navegador não suporta visualização de PDF, <a href={pdfUrl}>clique aqui</a> para baixar o arquivo.
      </iframe>
    </div>
  );
};

export default Terms;
